import { PlausibleEvent } from 'enums/plausible'
import { useEffect } from 'react'
import usePlausible from 'utils/hooks/usePlausible'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import Head from 'next/head'

import MainLayout from 'layouts/MainLayout'
import { getTitleLocation, MetaTypeNames } from 'pages'

import StructuredData from 'components/StructuredData/StructuredData'
import Coverage from 'sections/Coverage/Coverage'
import OurProgress from 'sections/OurProgress/OurProgress'
import OurStoryInNumbers from 'sections/OurStoryInNumbers/OurStoryInNumbers'
import PaymentSystems from 'sections/PaymentSystems/PaymentSystems'
import Support from 'sections/Support/Support'

const DynamicRestrictedModal = dynamic(() => import('components/RestrictedModal'))

export default function Home({
  referrer,
  ssrHost,
}: {
  referrer: string
  ssrHost: string
}) {
  const { t } = useTranslation(['seo', 'main', 'stats'])

  const setEvent = usePlausible()

  useEffect(() => {
    setEvent(PlausibleEvent.OpenedStats, {
      step: 1,
      referrer,
    })
  }, [])

  const info = useInfoProviderContext()

  if (info?.restricted === true) {
    return <DynamicRestrictedModal />
  }
  return (
    <div>
      <StructuredData
        host={ssrHost}
        variant="reduced"
        orgDetails
        path="/about/stats"
        pageTitle={t(`seo:${getTitleLocation(ssrHost, 'stats', MetaTypeNames.Title)}`)}
      />
      <Head>
        {/* t(`seo:statsTitle`) */}
        {/* t(`seo:statsTitle24`) */}
        <title>{t(`seo:${getTitleLocation(ssrHost, 'stats', MetaTypeNames.Title)}`)}</title>
        {/* t(`seo:statsDescription`) */}
        {/* t(`seo:statsDescription24`) */}
        <meta
          name="description"
          content={t(`seo:${getTitleLocation(ssrHost, 'stats', MetaTypeNames.Description)}`)}
        />

        <meta
          property="og:title"
          content={t(`seo:${getTitleLocation(ssrHost, 'stats', MetaTypeNames.Title)}`)}
        />
        <meta
          property="og:description"
          content={t(`seo:${getTitleLocation(ssrHost, 'stats', MetaTypeNames.Description)}`)}
        />
        <meta property="og:image" content={`https://${ssrHost}/images/ogImages/aboutStats.png`} />
        <meta property="og:site_name" content="Binany - Online Platform for Trading" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://${ssrHost}/about/stats`} />
      </Head>
      <MainLayout>
        <OurStoryInNumbers
          breadcrumbs={[
            { title: t('main:binanyTrading'), link: '/' },
            { title: t('stats:ourStoryTitle'), link: '/about/stats' },
          ]}
          host={ssrHost}
        />
        <OurProgress />
        <Support referrer={referrer} />
        <PaymentSystems />
        <Coverage />
      </MainLayout>
    </div>
  )
}

export async function getServerSideProps({ locale, req }) {
  return {
    props: {
      ssrHost: req.headers.host || '',
      ...(await serverSideTranslations(locale, ['main', 'seo', 'stats', 'contacts', 'shared'])),
    },
  }
}
